import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose, branch, renderNothing } from 'recompose';
import rpCookie from 'rp-cookie';
import PaymentList from './PaymentList';
import PaymentButton from './PaymentButton';
import { addCardSuccess } from '../../../../../actions/payment';
import parseCreditCard from '../../../helpers/parseCreditCard';
import styles from './PaymentDetails.scss';

const ADD_CARD_SUCCESS = 'addCardSuccess';

class PaymentDetails extends Component {
  onMessageHandler = ({ data }) => {
    if (data === ADD_CARD_SUCCESS) {
      this.paymentWindow.close();
      this.props.addCardSuccess();
      window.removeEventListener('message', this.onMessageHandler);
    }
  };
  handleCardAdd = () => {
    const session = rpCookie.sharedPermanent.get('rp_guid');
    this.paymentWindow = window.open(`${global.__PRELOADED_STATE__.config.paymentPageUrl}/?action=addCard&returnUrl=${encodeURIComponent(`//${global.location.host}/subscriptions/my-account/`)}&guid=${session}`);
    window.addEventListener('message', this.onMessageHandler);
  };

  render() {
    return (
      <div className={styles.root}>
        <div className={styles.card}>
          <input
            type="radio"
            id="radiorenew"
            name="radiorenew"
            className={styles.input}
            disabled
            checked
                    />
          <label className={styles.label} htmlFor="radiorenew" />
          <PaymentList card={parseCreditCard(this.props.card)} />
        </div>
        <PaymentButton onClick={this.handleCardAdd}>Add new card</PaymentButton>
      </div>
    );
  }
}

export default compose(
  connect(null, { addCardSuccess }),
  branch(
    props => props.expired,
    renderNothing,
  ),
)(PaymentDetails);
